(() => {
  const guard = window.foundationsQuantity;
  let adding = false;
  const checking = new Set();
  const approved = new WeakSet();

  const count = (cart) => cart.items.reduce(
    (total, item) => total + (String(item.product_id) === guard.productId ? item.quantity : 0), 0
  );

  const quantityInputs = (form) => [...form.querySelectorAll(`[name="updates[]"][data-quantity-variant-id="${guard.variantId}"]`)];
  const exceedsInputLimit = (form) => quantityInputs(form).reduce((total, input) => total + Number(input.value), 0) > 1;

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (Array.isArray(event.cartData?.items)) guard.inCart = count(event.cartData);
  });

  const readCart = async () => {
    try {
      const response = await fetch(`${window.routes.cart_url}.js`, { cache: 'no-store' });
      if (!response.ok) throw new Error();
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error();
      return cart;
    } catch {
      throw new Error(guard.checkError);
    }
  };

  guard.add = async (config) => {
    if (adding) throw new Error(guard.limitMessage);
    adding = true;
    try {
      const cart = await readCart();
      guard.inCart = count(cart);
      if (guard.inCart > 0) throw new Error(guard.limitMessage);
      config.body.set('quantity', '1');
      const response = await fetch(window.routes.cart_add_url, config);
      if (response.ok) guard.inCart = 1;
      return response;
    } finally {
      adding = false;
    }
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const button = event.submitter;
    if (!['cart', 'CartDrawer-Form', 'cart-notification-form'].includes(form.id)) return;
    const inputs = quantityInputs(form);
    if (button?.name !== 'checkout' || (!guard.inCart && inputs.length === 0)) return;
    if (approved.has(form)) return;
    event.preventDefault();
    if (checking.has(form.id)) return;
    checking.add(form.id);
    const wasDisabled = button.disabled;
    button.disabled = true;
    let notice = form.querySelector('[data-foundations-quantity-error]');
    if (notice) notice.remove();
    try {
      if (exceedsInputLimit(form)) {
        throw new Error(guard.limitMessage);
      }
      const cart = await readCart();
      guard.inCart = count(cart);
      if (guard.inCart > 1) throw new Error(guard.limitMessage);
      const liveForm = document.getElementById(form.id);
      const liveButton = liveForm && [...liveForm.elements].find((control) => control.name === 'checkout');
      if (!liveForm || !liveButton) return;
      if (exceedsInputLimit(liveForm)) throw new Error(guard.limitMessage);
      if (liveButton !== button && liveButton.disabled) throw new Error(guard.checkError);
      button.disabled = wasDisabled;
      approved.add(liveForm);
      try {
        liveForm.requestSubmit(liveButton);
      } finally {
        approved.delete(liveForm);
      }
    } catch (error) {
      const liveForm = document.getElementById(form.id);
      if (!liveForm) return;
      liveForm.querySelector('[data-foundations-quantity-error]')?.remove();
      notice = document.createElement('p');
      notice.dataset.foundationsQuantityError = '';
      notice.setAttribute('role', 'alert');
      notice.textContent = `${error.message} `;
      const link = document.createElement('a');
      link.href = window.routes.cart_url;
      link.textContent = guard.viewCart;
      notice.append(link);
      liveForm.append(notice);
    } finally {
      button.disabled = wasDisabled;
      checking.delete(form.id);
    }
  }, true);
})();
